import React from 'react'
import { connect } from 'react-redux'
import { doGetCustomTemplateList, doGetPrintTemplateList, doDefultCoordinator, doGetArchivesTempletList } from 'tyan/reducers/actions'
import CustomTemplateDiv from './CustomTemplateDiv'

const sysTemplate = {
  // '邮件模板设置': EmailTempletListDiv,
  // '打印机端口': PrinterListDiv,
  // 'App登录设置': AppLoginSettingListDiv,
}

class SysSettings extends React.Component {
  state = {
    initValues系统模板: {
      ...(Object.keys(sysTemplate).reduce((a, v, i) => {
        a['模板'].push(i + 1)
        a[`模板[${i + 1}].id`] = i + 1
        a[`模板[${i + 1}].模板名称`] = v
        return a
      }, { '模板': [] })),
    },
  }

  componentDidMount = () => {
    this.handleInitCustomTemplate()
  }

  //自定义模板
  handleInitCustomTemplate = () => {
    const { onSave, onClose, dispatch } = this.props
    dispatch(doGetCustomTemplateList({
      onEnd: ({ errorMessage, initValues自定义模板 }) => {
        if (errorMessage) {
          Tyan.pubForm.showError(errorMessage)
        }
        else if (initValues自定义模板) {
          this.setState({ initValues自定义模板 })
        }
      }
    }))
  }

  handleAddCustomTemplate = (data) => {
    Tyan.pubForm.showDialog('自定义模板', props => <CustomTemplateDiv {...props} id={-1} onSave={this.handleInitCustomTemplate} />)
    this.setState({})
  }

  handleEditSysCustomTemplate = (data) => {
    Tyan.pubForm.showDialog('自定义模板', props => <CustomTemplateDiv {...props} id={data.id} onSave={this.handleInitCustomTemplate} />)
    this.setState({})
  }

  fieldset自定义模板 = () => {
    return [{
      _grid: '', name: '模板', rowNumbers: true, height: '100%',
      columns: [
        { _text: '模板名称', flex: 1 },
        { _text: '显示名称', flex: 1 },
      ],
      buttons: [
        { _button: '添加新模板...', handler: this.handleAddCustomTemplate, },
      ],
      onDoubleTap: this.handleEditSysCustomTemplate,
    }]
  }

  render = () => {
    const { showBody: Body } = this.props

    return <Body fullForm data={this}
      fieldsets={[
        { title: '自定义模板', _fieldset: this.fieldset自定义模板(), fullblock: true },
      ]}
    />
  }
}

export default connect()(SysSettings)